/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export enum RotateElementDirection {
  Left,
  Right,
}
